export const VIEWPORT_VALUE_CONFERENCE_MODE = 'width=device-width, initial-scale=1.0, user-scalable=no, maximum-scale=1'
export const VIEWPORT_VALUE_PC_APP_MODE = 'width=1480'
export const changeViewPort = (viewportContentValue = VIEWPORT_VALUE_PC_APP_MODE) => {
  const viewportMetaEl = document.querySelector('meta[name=viewport]')
  if (viewportMetaEl) {
    viewportMetaEl.content = viewportContentValue
  }
}
